import { render, staticRenderFns } from "./ActivityReviewForm.vue?vue&type=template&id=0883dcb6&"
import script from "./ActivityReviewForm.vue?vue&type=script&lang=js&"
export * from "./ActivityReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports